import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, Navbar, Nav, Badge } from 'react-bootstrap';
import { busca_censo } from "../../services/api";

const Alunos_censo = () => {
    const navigate = useNavigate();

    // Estados
    const [dadosCenso, setDadosCenso] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'bairro', direction: 'asc' });

    const fetchData = async () => {
        try {
            const response = await busca_censo();
            const listaSaneada = Array.isArray(response) ? response : (response?.data || []);
            setDadosCenso(listaSaneada);
        } catch (error) {
            console.error("Erro ao buscar dados do censo:", error);
            setDadosCenso([]);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Função de Ordenação
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...dadosCenso].sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        // Converter para número se for possível, para ordenação correta
        if (!isNaN(valA) && !isNaN(valB)) {
            valA = parseFloat(valA);
            valB = parseFloat(valB);
        }

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const formatCurrency = (value) => {
        const val = parseFloat(value || 0);
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
    };

    // Helper para ícones de ordenação
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return " ↕";
        return sortConfig.direction === 'asc' ? " 🔼" : " 🔽";
    };

    return (
        <div style={{ paddingBottom: '80px' }}>
            <Navbar sticky="top" className="bg-body-tertiary px-3 shadow-sm">
                <Nav.Link href="/" className="me-auto">Santa Mônica Rede de Ensino</Nav.Link>
                <Navbar.Brand className="me-auto fs-6 fw-bold text-primary">CENSO POPULACIONAL E MERCADO</Navbar.Brand>
                <Button variant="danger" size="sm" onClick={() => navigate("/login")}>Sair</Button>
            </Navbar>

            <div className="container-fluid mt-3 px-4">
                <div className="table-responsive shadow-sm" style={{ maxHeight: '75vh' }}>
                    <Table striped bordered hover size="sm" className="align-middle bg-white">
                        <thead className="table-dark text-center sticky-top">
                            <tr>
                                <th rowSpan="2" className="align-middle" onClick={() => requestSort('bairro')} style={{ cursor: 'pointer' }}>
                                    BAIRRO {getSortIcon('bairro')}
                                </th>
                                <th colSpan="5" className="bg-primary">ALUNOS SMREDE (INTERNO)</th>
                                <th colSpan="1" className="bg-success">INEP</th>
                                <th colSpan="6" className="bg-info text-dark">DADOS POPULACIONAIS E FINANCEIROS (IPP)</th>
                            </tr>
                            <tr style={{ fontSize: '10px', cursor: 'pointer' }}>
                                <th onClick={() => requestSort('alunos_rede_total')}>TOTAL {getSortIcon('alunos_rede_total')}</th>
                                <th onClick={() => requestSort('alunos_rede_0_4')}>0-4 {getSortIcon('alunos_rede_0_4')}</th>
                                <th onClick={() => requestSort('alunos_rede_5_9')}>5-9 {getSortIcon('alunos_rede_5_9')}</th>
                                <th onClick={() => requestSort('alunos_rede_10_14')}>10-14 {getSortIcon('alunos_rede_10_14')}</th>
                                <th onClick={() => requestSort('alunos_rede_15_19')}>15-19 {getSortIcon('alunos_rede_15_19')}</th>
                                <th onClick={() => requestSort('total_escolas_concorrencia')}>ESCOLAS {getSortIcon('total_escolas_concorrencia')}</th>
                                <th onClick={() => requestSort('ipp_pop_0_4')}>POP 0-4 {getSortIcon('ipp_pop_0_4')}</th>
                                <th onClick={() => requestSort('ipp_pop_5_9')}>POP 5-9 {getSortIcon('ipp_pop_5_9')}</th>
                                <th onClick={() => requestSort('ipp_pop_10_14')}>POP 10-14 {getSortIcon('ipp_pop_10_14')}</th>
                                <th onClick={() => requestSort('ipp_pop_15_19')}>POP 15-19 {getSortIcon('ipp_pop_15_19')}</th>
                                <th onClick={() => requestSort('ipp_renda_media')}>RENDA MÉDIA {getSortIcon('ipp_renda_media')}</th>
                                <th onClick={() => requestSort('ipp_renda_mediana')}>RENDA MEDIANA {getSortIcon('ipp_renda_mediana')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedData.map((item, index) => (
                                <tr key={index} className="text-center">
                                    <td className="text-start fw-bold small">{item.bairro}</td>
                                    <td><Badge bg="primary">{item.alunos_rede_total}</Badge></td>
                                    <td className="small">{item.alunos_rede_0_4}</td>
                                    <td className="small">{item.alunos_rede_5_9}</td>
                                    <td className="small">{item.alunos_rede_10_14}</td>
                                    <td className="small">{item.alunos_rede_15_19}</td>
                                    <td className="table-success fw-bold">{item.total_escolas_concorrencia}</td>
                                    <td className="small">{item.ipp_pop_0_4}</td>
                                    <td className="small">{item.ipp_pop_5_9}</td>
                                    <td className="small">{item.ipp_pop_10_14}</td>
                                    <td className="small">{item.ipp_pop_15_19}</td>
                                    <td className="small fw-bold text-success">{formatCurrency(item.ipp_renda_media)}</td>
                                    <td className="small text-muted">{formatCurrency(item.ipp_renda_mediana)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>

            <footer className="fixed-bottom bg-dark text-white p-2 shadow-lg">
                <div className="container-fluid d-flex justify-content-around align-items-center">
                    <span>Bairros Listados: <Badge bg="primary">{dadosCenso.length}</Badge></span>
                    <span>Total de Alunos na Rede: <Badge bg="success">
                        {dadosCenso.reduce((acc, curr) => acc + parseInt(curr.alunos_rede_total || 0), 0)}
                    </Badge></span>
                </div>
            </footer>
        </div>
    );
}

export default Alunos_censo;